<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="isValid" ref="form">

          <v-card>
            <v-toolbar color="white" fixed>
              <h3>{{ $i18n.t(label) }}</h3>
            </v-toolbar>
            <v-card-text>
              <v-container class="py-0">
                <v-row class="mt-4">
                  <v-col cols="12" md="4">
                    <v-text-field :label="$i18n.t('Name')" v-model="branch.name"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" v-if="branch.corp_id">
                    <z-entity-select :corp="branch.corp_id" v-model="branch.entity" :label="$i18n.t('Entity')"
                      autoSelect hideLone />
                  </v-col>
                </v-row>
                <v-card>
                  <v-btn color="grey" small class="left-headers">
                    <h3>{{ $i18n.t("Staff Details") }}</h3>
                  </v-btn>
                  <v-btn x-small color="blue" class="right-headers" style="float: right"
                    v-on:click="addItem(branch.staff)">+
                    {{ $i18n.t("Add ") }}</v-btn>

                  <v-row v-for="(staff, index) in branch.staff" :key="index" style="padding: 10px 10px">
                    <v-col cols="12" md="4">
                      <z-driver-select idOnly v-model="staff.empId" :label="$i18n.t('Employee')" />
                    </v-col>
                    <z-name-master-select :label="'Employee Type *'" v-model="staff.title_id" :type="14" />
                    <v-col cols="12" md="1">
                      <v-btn @click="remove(index)" fab small text color="error">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select class="purple-input" v-model="branch.address.country"></z-country-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-state-select class="purple-input" v-model="branch.address.state"
                      :country="branch.address.country"></z-state-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-city-select class="purple-input" v-model="branch.address.city" :state="branch.address.state"
                      :country="branch.address.country"></z-city-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field :label="$i18n.t('Address')" dense v-model="branch.address.addressLine"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <v-btn color="success darken-1" @click="save()" :loading="loading" :disabled="!isValid">Save</v-btn>
            </v-card-actions>
          </v-card>

        </v-form>
      </v-col>
    </v-row>

    <z-audit-log v-if="branch" :showDialog="showAuditLog" :branch_id="branch._id" branch="Branch"
      @closeAuditLog="showAuditLog = false">
    </z-audit-log>
  </v-container>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "BranchCreate",
  props: {
    label: {
      default: "Create Branch",
    },
    branch_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
    forClient: {
      default: null,
    },
    value: {
      default: null,
    },
  },
})
export default class BranchCreate extends Vue {
  isValid = true;
  isEdit = false;
  showAuditLog = false;
  branchPOSO = {
    corp_id: null,
    name: null,
    address: { country: null, state: null, city: null, addressLine: null },
    staff: [{
      empId: null,
      title_id: null
    }]
  };
  branch = this.branchPOSO;

  select(data) {
    this.$emit("select", data);
  }

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    addressCountry: [(v) => !!v || this.$i18n.t("Country is required")],
    addressCity: [(v) => !!v || this.$i18n.t("City is required")],
    addressState: [(v) => !!v || this.$i18n.t("State is required")],
    addressAddressLine: [(v) => !!v || this.$i18n.t("Address is required")]
  };

  addItem(_list) {
    if (!_list) {
      _list = [];
    }
    _list.push({
      empId: null,
      title_id: null
    });
    return _list;
  }

  id = null;

  get loading() {
    return common.loading;
  }

  remove(_index) {
    this.branch.staff.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      if (this.branch.name == null || this.branch.name == "" || this.branch.name == undefined) {
        common.setError("Branch name empty!");
        common.setLoading(false);
      } else {
        const response = await doPost("/api/branch/save", this.branch);
        common.showMessage(`Branch${response.name} Saved Successfully`);
        common.setLoading(false);
        if (this.singlePage) {
          this.$emit("select", {
            name: response.name,
            _id: response._id,
          });
          this.branch = this.branchPOSO;
          this.$emit("reload");
        }
        else {
          if (!this.id) this.$router.push("/branch/" + response._id);
          this.get(response._id);
        }
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
  prepareResponse(response) {
    if (!response) response = {};
    if (!response.name) response.name = null;
    for (let index = 0; index < response.staff.length; index++) {
      if (!response.staff[index].empId)
        response.staff[index].empId = null;
      if (!response.staff[index].title_id)
        response.staff[index].title_id = null;
    }
    if (!response.entity_id) response.entity_id = null;
    if (!response.address) response.address = {};
    if (!response.address.country) response.address.country = null;
    if (!response.address.state) response.address.state = null;
    if (!response.address.city) response.address.city = null;
    if (!response.address.addressLine) response.address.addressLine = null;
  }

  async get(id) {
    try {
      const branch = await doGet("/api/branch/" + id + "/detail");
      this.prepareResponse(branch);
      this.branch = branch;
      this.id = this.branch._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.singlePage) {
      if (this.branch_id) {
        await this.get(this.branch_id);
      }
    } else if (this.value) {
      this.prepareResponse(this.value);
      this.branch = this.value;
      this.id = this.branch._id;
    } else if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    await init.getUrlParameter("forCorp");
    if (init.urlParam) {
      this.branch.corp_id = init.urlParam;
    }
    if (this.forClient) this.branch.corp_id = this.forClient;
  }
}
</script>

<style scoped>
.left-headers {
  text-transform: none;
  top: -15px;
  left: 10px;
  font-size: 12px;
}

.right-headers {
  text-transform: none;
  top: -10px;
  left: 10px;
  font-size: 12px;
}
</style>
